
/*
DOKUMNENTACIJA:

ter-super-validator-lib.js
Funkcije koje vrse validaciej celog drafta, unakrsno i slozeno...

HELPERI (sufix Helper) su u stvari REDUCER HELPERI i oni su zapravo izdvojeni deo reducera koji prima i vraca ceo state.
Ostale funkcije obavljaju CRUD operacije ali ne znaju za ceo state nego samo za podatke koji su njihova briga.
*/

import { version } from "react";
import { terUtilsSelectKlimaKomoraBySubkey, terUtilsSelectModulWhere } from "./ter-selectors";
import { validatorKlimaKomora } from "./ter-validator-lib";

export const terSuperValidatorAllHelper = (state, payload) => {
  let { valid, superErrors } = payload;
  let readme = 'Svi implementirani testovi supervalidacije su potvrdili validnost';
  if (valid !== true) {
    readme = 'Najmanje jedan od testova supervalidaciej nije prosao';
  }
  return {
    ...state,
    superValidacija: {
      valid: valid,
      readme,
      ...superErrors
    }
  };
};


export const terSuperValidatorAll = (draft, cb) => {
  let valid = true; // presuda
  // let sastavnicaValid = true;
  /*
  superErrors je object koji sadrzi array errors sa pojedinacnim greskama i neke propertije za najvaznije supervalidacije kao na primer, da li je projekat ucitan u editor (ako nije editor ne treba da funkcionise). dakle u pitanju je kombinacija objecta i array-a.
  */
  let s = {
    errors: []
  }; // superErrors
  let v;

  // supervalidator koji upozorava da je freshness izmenjena
  v = terSupervalidatorDimenzijeModulaIzmenjene(draft);
  if (v.valid === false) {
    valid = false;
    s = {
      ...s,
      errors: [
        ...s.errors,
        {
          errorName: 'Dimenzije modula izmenjene',
          errorParams: v.errors
        }
      ]
    }
  }

  // { valid, errors } = terSuperValidatorBrojeviModula(draft.mm);
  /*
  v = terSuperValidatorBrojeviModula(draft.mm);
  if (v.valid === false) {
    valid = false;
    s = {
      ...s,
      errors: [
        ...s.errors,
        {
          errorName: 'Brojevi Modula',
          errorParams: v.errors
        }
      ]
    }
  }
  */

  v = terSuperValidatorZaDveVelicineModula(draft.kk, draft.mm);
  if (v.valid === false) {
    valid = false;
    s = {
      ...s,
      errors: [
        ...s.errors,
        {
          errorName: 'Dve velicine modula',
          errorParams: v.errors
        }
      ]
    }
  }

  v = superValidatorNosilacTroska(draft);
  if (v.valid === false) {
    valid = false;
    let nosilacTroskaValid = false;
    s = {
      ...s,
      errors: [
        ...s.errors,

        {
          errorName: 'Nosilac troska',
          errorParams: v.errors
        }
      ],
      nosilacTroskaValid: nosilacTroskaValid
    }
  }

  v = terSuperValidatorDuzinaModula(draft.mm, draft.kk);
  if (v.valid === false) {
    valid = false;
    s = {
      ...s,
      errors: [
        ...s.errors,
        {
          errorName: 'Modul',
          errorParams: v.errors
        }
      ]
    }
  }

  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(valid, s);
  };
  return;
};


const terSuperValidatorBrojeviModula = (mm) => {
  let valid = true;
  let _supererrors = {};
  let brojeviModula = [];
  mm.forEach(m => {
    if (!brojeviModula.includes(m.brojmodula)) {
      brojeviModula.push(m.brojmodula);
    } else {
      valid = false;
      // _supererrors = 'Modul sa tim brojem vec postoji!';
      // _supererrors.KilmakomoraValid = false;
      // _supererrors.KilmakomoraInvalidMsg = 'Modul sa tim brojem vec postoji!';
      _supererrors.field = 'brojmodula';
      _supererrors.msg = 'Postoje dva modula sa istim brojem u istoj klima komori!';
    }
  });
  return {
    valid,
    errors: _supererrors
  };
}

const terSuperValidatorZaDveVelicineModula = (kk, mm) => {
  let valid = true;
  let _supererrors = {};

  kk.forEach(k => {
    if (valid === true) {
      if (k.flag_dvevelicine === true) {
        // dve visine - validno uvek
      } else {
        // jedna visina
        let mm_odK = terUtilsSelectModulWhere(k.subkey, mm);
        if (valid === true) {
          mm_odK.forEach(m => {
            if (m.kojavelicina === "2") {
              valid = false;
            }
            // TODO za ubuduce moze poboljsanje: ukoliko koristimo custom dimenzije da onda nije bitno da li je odabrano 1 ili 2....?
          });
        }
      }
    }
  });

  if (valid === false) {
    _supererrors.field = 'velicinaModula';
    _supererrors.msg = 'Klima komora ima jednu velicinu a neki od modula je podesen za velicinu "2"!';
  }

  return {
    valid,
    errors: _supererrors
  };
}


export const superValidatorNosilacTroska = (draft) => {
  // console.log('Nosilac troska validator');
  let zaglavlje = draft.virbom_header;
  // console.log(n);
  let valid = true; // test je inicijalno polozen
  // let _supererrors = {};
  let errors = {};
  // ovde se kasnije dodaju validatori koji mogu da obore test

  // ne samo svako polje da ima jedan test nego razne provere unakrsne podatak iz draft-a...

  if (!zaglavlje.nazivprojekta || (zaglavlje.nazivprojekta === '')) {
    valid = false;
    // errors = 'Naziv projekta troska mora biti unet!';
    // errors.nosilacTroskaValid = false;
    // errors.nosilacTroskaInvalidMsg = 'Naziv projekta troska mora biti unet!';
    errors.field = 'nazivprojekta';
    errors.msg = 'Naziv projekta mora biti unet!';
  }

  /*
  // nakon zavrsetka svih testova
  if (typeof cb === 'function') {
    cb(valid, _supererrors);
  };
  */

  // Mrzi nas da stalno kucamo pa cemo da stavimo return true dok razvijamo
  // return true;
  return { valid, errors };
};

const terSuperValidatorDuzinaModula = (mm, kk) => {
  let valid = true;
  let _supererrors = {};
  let brojeviModula = [];
  mm.forEach(m => {
    let k = terUtilsSelectKlimaKomoraBySubkey(m.parent_subkey, kk);
    // console.log('**** SIFRA KOMORE ', k)
    if (m.duzinamodula === '' || m.duzinamodula === '000') {
      valid = false;
      _supererrors.field = 'duzinamodula';
      _supererrors.msg = `Modul u klima komori: ${k.sifrakomore} nema unetu duzinu!`;
    }
  });
  return {
    valid,
    errors: _supererrors
  };
}


const terSupervalidatorDimenzijeModulaIzmenjene = (draft) => {
  // supervalidator koji upozorava da je freshness izmenjena
  let valid = true;
  let _supererrors = {};
  if (draft.freshness === draft.zaSupervalidatorDimenzijeModulaIzmenjene) {
    valid = false;
    _supererrors.field = 'dimenzijemodulaizmenjene';
    _supererrors.msg = `Proverite da li treba da izmenite dimenzije eliminatora kapi`;
  }
  return {
    valid,
    errors: _supererrors
  };
};
